<div *ngIf="fidelityProducts && fidelityProducts.length > 0">

  <div class="text-sm text-gray-800 font-semibold"
       class="mx-4 my-6">{{(available ? "slider.canOffer" : "slider.soonAvaible") |translate}}</div>

  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">

    <!-- Produit -->
    <div *ngFor="let prod of fidelityProducts;let first=first"
         class="bg-white rounded-lg shadow-md p-2 flex items-center gap-4 hover:shadow-lg transition cursor-pointer border border-gray-300">
      <img src="{{prod.image[0]}}" alt="Produit 1" class="w-12 h-12 rounded-lg object-cover">
      <div class="flex-1">
        <h3 class="text-sm font-medium text-gray-800">{{prod.display_lang.name | capitalize}}</h3>
      </div>
      <span class="bg-indigo-600 text-white text-xs px-2 py-1 rounded-full shadow">{{prod.fidelity_points}}pts</span>
    </div>

  </div>

</div>
